// IMAGE SLOTS (Kampsport Kids Ready, Swedish copy of Martial Arts Kids Class Ready)
// Hosted on Higgsfield (cloudfront) until the Swedish Impultienda store exists (Impultienda had no free store slot on 26/10).
const H = 'https://d2ol7oe51mr4n9.cloudfront.net/user_3DMFLKCotDruk7RKAWz1zy5qmH0/';

/**
 * iMac + 3 tablets + 2 phones, one bonus per device. Composited in code (no AI text): the Swedish Gamma Studio cover plus
 * real pages on the iMac, and the bonus photos with their Swedish titles typed in. Pure white background.
 */
const IMAC = H + 'c4647a6d-41d6-49e4-a2ed-14a7c8b1f887.jpg';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/**
 * Real pages of the Swedish Gamma Studio book (9:16), same order as lookInside.captions: p.4, 8, 32, 36, 37, 39.
 * Only pages that passed the page-by-page check of the Swedish book (26/10, producto-studio/qc.md): clean (8, 32, 39)
 * or with tiny details that don't show (4, 36, 37). Never the pages with DRILL, wrong ages, sparring, 38 or 40.
 */
export const pageImages: string[] = [
  H + '62b6e185-6446-4ebe-bcfd-957892b3b1b6.jpg',
  H + '951f7307-56fa-41d6-854f-0aebdd33a3b5.jpg',
  H + '9d7d0739-977c-4737-ac5d-377d19eacbd8.jpg',
  H + '0da5f9b4-c2a6-410a-88b2-8c3eedddffe6.jpg',
  H + '0112b705-3750-4cbc-9aab-c5d5a1cdd061.jpg',
  H + '273bae53-bcbc-4c27-9e27-a0b8ce1aae34.jpg',
];
/** 5 bonus covers (Swedish titles typed in code), in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  H + '429f7255-f6b7-4412-8765-f19bc61fc742.jpg',
  H + '7b6beab3-8423-432a-bcd8-07ab471bcf99.jpg',
  H + 'f4d45c51-384f-49b2-87e4-de09b10a4204.jpg',
  H + '23624654-1d29-4b4b-874c-094c9b7083e0.jpg',
  H + 'f2c3a2f3-b469-4968-bb2b-faf6e246f26c.jpg',
];
